import React, { useState } from 'react';
import './FAQSection.css';

const FAQSection = ({
  title = "Frequently Asked Questions",
  subtitle = "Look, we know choosing online Quran education is a big decision. You might have questions. Here's what most people ask us.",
  isUsaPage = false
}) => {
  // Track the single open FAQ id. Only one FAQ may be open at a time.
  const [openId, setOpenId] = useState(null);

  const toggleFAQ = (id) => {
    setOpenId(prev => (prev === id ? null : id));
  };

  const leftFAQs = [
    {
      id: 'left-0',
      question: 'What are online Quran classes, and how do they work?',
      answer: 'Live, one-on-one video sessions with a certified tutor, scheduled around your time zone and availability.'
    },
    {
      id: 'left-1',
      question: "Can I schedule classes around my child's school hours and activities?",
      answer: "Yes. Scheduling stays flexible and can be adjusted as your child's routine changes throughout the year."
    },
    {
      id: 'left-2',
      question: "What's the difference between Tajweed and regular Quran reading?",
      answer: (<>
        Reading classes build the basic skill of recognizing and reciting Arabic script. <a style={{ textDecoration: "none", color: "#006100", fontWeight: "bold" }} href="/online-tajweed-classes-tajweed-course/">Learning tajweed</a> goes a step further, focusing on the rules of correct pronunciation and articulation.

      </>
      )
    }
  ];

  const rightFAQs = [
    {
      id: 'right-0',
      question: 'Are your online Quran classes suitable for complete beginners?',
      answer: isUsaPage ? (
        'Yes. We have designed our curriculum to accommodate absolute beginners, children as young as 4, and adults with no prior Arabic or Quranic knowledge. We start from the very beginning with Noorani Qaida Course and Madni Qaida, building the correct foundation before progressing to Quran reading and recitation.'
      ) : (
        <>
          Yes. Most students start with no prior knowledge of Arabic script at all. Our basic courses like <a style={{ color: "#006100", textDecoration: "none", fontWeight: "bold" }} href="/noorani-qaida-course/">Noorani Qaida</a> are built specifically for that starting point.


        </>
      )
    },
    {
      id: 'right-1',
      question: 'How do I choose between a male and female tutor?',
      answer: (
        <>
          Just let us know your preference when you register, and we'll match you accordingly. There's no extra cost either way. <a style={{ textDecoration: "none", color: "#006100", fontWeight: "bold" }} href="/free-trial/">Register here</a> for a 3-day free trial.
        </>
      )
    },
    {
      id: 'right-2',
      question: "What's the best age to start online Quran classes for kids?",
      answer: "We take students from age 4, usually starting with Noorani Qaida. It depends on where a student starts and how consistent they are, but most beginners see clear progress within their first month."
    },
    {
      id: 'right-3',
      question: 'Are you available in Canada or just the US?',
      answer: (
        <>
          Yes, we are available across the USA, including Texas, New York, California, Florida, and New Jersey in you neighbour hood. We also serve across <a style={{ textDecoration: "none", color: "#006100", fontWeight: "bold" }} href="/online-quran-classes-canada/">Canada</a> to teach Quran online.
        </>
      )
    },

  ];

  return (
    <section className="faq-section" id="faq">
      <div className="faq-section__container">
        <div className="faq-section__grid">
          {/* Left Column: Heading and Left Accordion FAQs */}
          <div className="faq-section__col faq-section__col--left">
            <h2 className="faq-section__title">
              {title}
            </h2>
            <p className="faq-section__subtitle">
              {subtitle}
            </p>

            <div className="faq-section__accordion">
              {leftFAQs.map((faq) => (
                <div key={faq.id} className={`faq-item ${openId === faq.id ? 'faq-item--open' : ''}`}>
                  <button
                    className="faq-item__header"
                    onClick={() => toggleFAQ(faq.id)}
                    aria-expanded={openId === faq.id}
                  >
                    <span>{faq.question}</span>
                    <svg className="faq-item__icon" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
                    </svg>
                  </button>
                  <div className="faq-item__body">
                    <div className="faq-item__content">
                      <p>{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Column: Right Accordion FAQs */}
          <div className="faq-section__col faq-section__col--right">
            <div className="faq-section__accordion">
              {rightFAQs.map((faq) => (
                <div key={faq.id} className={`faq-item ${openId === faq.id ? 'faq-item--open' : ''}`}>
                  <button
                    className="faq-item__header"
                    onClick={() => toggleFAQ(faq.id)}
                    aria-expanded={openId === faq.id}
                  >
                    <span>{faq.question}</span>
                    <svg className="faq-item__icon" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
                    </svg>
                  </button>
                  <div className="faq-item__body">
                    <div className="faq-item__content">
                      <p>{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;

